import Header from "components/ui/Header/Header";
import React from "react";
import ResultScreen from "routes/Details/screens/ResultScreen/ResultScreen";
import styles from "./styles.module.scss";
import useGetStatus from "hooks/api/useGetStatus";
import LoadingScreen from "components/base/LoadingScreen";

const DetailsRoute = () => {
  const { isLoading: isLoadingStatus } = useGetStatus();

  return (
    <>
      <Header />
      <div className={styles.screenContainer}>
        {isLoadingStatus ? <LoadingScreen type={"light"} isLoading /> : <ResultScreen />}
      </div>
    </>
  );
};

export default DetailsRoute;
